import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWebSocket } from '../WebSocketContext';

import logger from './../utils/logger.js';



const ProctoringViolationHandler = () => {
  const navigate = useNavigate();
  const { ws, wsMessageEvent, callEnded } = useWebSocket();
  const hasNavigated = useRef(false);

  useEffect(() => {
    // Listen for WebSocket message events
    if (wsMessageEvent?.type === "multiple_side_camera_left" && !hasNavigated.current) {

      logger.debug("Multiple side camera left event received - ending call and navigating to violation page");

      
      // Mark as navigated to prevent duplicate navigation
      hasNavigated.current = true;
      
      // Navigate immediately to prevent automatic feedback navigation
      handleProctoringViolation();
    }
  }, [wsMessageEvent]);

  const handleProctoringViolation = async () => {
    try {

      logger.debug("Handling proctoring violation - multiple side camera attempts detected");

      // Navigate immediately to prevent automatic feedback navigation
      logger.debug("Navigating to proctoring violation page");
     

      // Navigate immediately to prevent automatic feedback navigation
 
      navigate('/proctoring-violation');

      // Clean up after navigation to prevent any interference
      setTimeout(async () => {
        // Clean up any Daily.co instances
        if (window?._dailyCallObject) {

          logger.debug("Found global Daily call object, destroying it");

      
          window._dailyCallObject.destroy();
          window._dailyCallObject = null;
        }

        // Reset the global flag that tracks Daily instances
        if (window?._dailyInstanceActive) {

          logger.debug("Resetting Daily instance active flag");

          window._dailyInstanceActive = false;
        }

        // Dispatch end interview call event
        if (window.dispatchEvent) {
          window.dispatchEvent(new Event("end_interview_call"));

          logger.debug("end_interview_call event dispatched");
        }

        // Turn off camera and microphone
        logger.debug("Turning off camera and microphone");
        try {
          const streams = await navigator.mediaDevices
            .getUserMedia({ audio: true, video: true })
            .catch((err) => logger.debug("Failed to get media streams:", err));


          if (streams) {
            streams.getTracks().forEach((track) => {
              track.stop();

              logger.debug(`Stopped ${track.kind} track`);
            });
          }
        } catch (mediaError) {
          logger.debug("Media cleanup error:", mediaError);

        }

        // Find and remove ALL iframe elements from the DOM
        const allIframes = document.querySelectorAll("iframe");

        logger.debug(`Found ${allIframes.length} iframes to remove`);
        allIframes.forEach((iframe) => {
          logger.debug("Removing iframe from DOM:", iframe);

          iframe.parentNode?.removeChild(iframe);
        });

        // End the call after cleanup to avoid triggering feedback navigation
        // Only call this if we're still on the violation page to avoid conflicts
        if (window.location.pathname === '/proctoring-violation' && callEnded) {

          logger.debug("Ending call after navigation");

          callEnded();
        }
      }, 100); // Small delay to ensure navigation happens first

    } catch (error) {

      logger.error("Error during proctoring violation cleanup:", error);

      // Still navigate even if cleanup fails
      navigate('/proctoring-violation');
    }
  };

  // This component doesn't render anything, it just handles the event
  return null;
};

export default ProctoringViolationHandler; 